export default __webpack_public_path__ + "static/media/acms-bo.9b5f9afd.svg";